export default __webpack_public_path__ + "static/media/pavan.366138ba.png";